import { ActionReducerMap } from '@ngrx/store';
import { uploadFileReducer } from './reducers/upload-file.reducer';
import { UploadScreenInfo } from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { UploadFileContactInformation } from '../pages/contact-information/model/potential-customer';
import { uploadFileOptionalReducer } from './reducers/contact-information.reducer';
import { uploadFileTaxReducer } from './reducers/upload-file-tax-information.reducer';
import { UploadScreenTaxInfo } from '../pages/tax-validation/model/tax-validation';

interface AppState {
  UploadFileInfo: UploadScreenInfo;
  UploadFileContactInformationInfo: UploadFileContactInformation;
  UploadFileTaxInfo: UploadScreenTaxInfo;
}

export const reducers: ActionReducerMap<AppState> = {
  UploadFileInfo: uploadFileReducer,
  UploadFileContactInformationInfo: uploadFileOptionalReducer,
  UploadFileTaxInfo: uploadFileTaxReducer,
};
